<template>
  <div class="contract-manage-tab tb">
    <custom-tab :list="tabData" v-model="tabIndex"></custom-tab>
    <manage v-if="`${tabIndex}` === '0'" :func-view="funcView"></manage>
    <device-list v-if="`${tabIndex}` === '1'"></device-list>
  </div>
</template>

<script>
import tableFilterValueMixins from '@/mixins/table_filterValue_mixins.js';
import manage from './children/manage';
import deviceList from './children/deviceList';

export default {
  name: 'contractManagement',
  mixins: [tableFilterValueMixins],
  props: {},
  components: {
    deviceList,
    manage,
  },
  data() {
    return {
      tabIndex: '',
    };
  },
  computed: {
    tabData() {
      const tabData = [];
      if (this.funcView.contract_info_list) {
        tabData.push({
          name: this.$t('crm_contractManagement.ding_dan'),
          value: 0,
        });
      }
      if (this.funcView.contract_info_device_list) {
        tabData.push({
          name: this.$t('crm_contractManagement.she_bei'),
          value: 1,
        });
      }
      return tabData;
    }
  },
  mounted() {
    this.getFuncView(null, () => {
      // 设置默认选中的tab
      let defaultTabIndex = '';
      if (this.funcView.contract_info_list) {
        defaultTabIndex = '0';
      } else if (this.funcView.contract_info_device_list) {
        defaultTabIndex = '1';
      }
      this.tabIndex = this.tabIndex ? this.tabIndex : defaultTabIndex;
    });
  },
  methods: {},
};
</script>

<style lang="scss">
.contract-manage-tab {
  padding-left: 0 !important;
}
</style>
